import PropertyGroup from './PropertyGroup';
import { PropertyItem } from './PropertyGroup.styles';
export default PropertyGroup;
export { PropertyItem };